
import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

const ImpressumPage = () => {
  useEffect(() => {
    document.title = 'Impressum - Jo Allround Service';
    
    // Schema.org JSON-LD für Impressum
    const schemaScript = document.createElement('script');
    schemaScript.type = 'application/ld+json';
    schemaScript.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "Impressum - Jo Allround Service",
      "description": "Impressum und rechtliche Angaben von Jo Allround Service - Handwerker und Hausmeister in Rheinsberg, OPR",
      "url": `${import.meta.env.VITE_SITE_URL || 'https://jo-allround.de'}/impressum`,
      "mainEntity": {
        "@type": "LocalBusiness",
        "name": "Jo Allround Service",
        "owner": {
          "@type": "Person",
          "name": "Nancy Born"
        },
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Kiefernweg 1",
          "postalCode": "16831",
          "addressLocality": "Rheinsberg",
          "addressRegion": "Brandenburg",
          "addressCountry": "DE"
        },
        "telephone": "03943 / 62 66 73",
        "email": "J-Born@T-Online.de"
      }
    });
    
    // Entferne vorhandenes Schema falls vorhanden
    const existingSchema = document.querySelector('script[type="application/ld+json"][data-page="impressum"]');
    if (existingSchema) {
      existingSchema.remove();
    }
    
    schemaScript.setAttribute('data-page', 'impressum');
    document.head.appendChild(schemaScript);
    
    return () => {
      const script = document.querySelector('script[type="application/ld+json"][data-page="impressum"]');
      if (script) {
        script.remove();
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <main className="pt-20">
        <div className="max-w-4xl mx-auto px-4 py-16">
          <h1 className="text-4xl font-bold text-gray-900 mb-8">Impressum</h1>
          
          <div className="prose prose-lg max-w-none">
            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Angaben gemäß § 5 TMG</h2>
              <div className="bg-gray-50 p-6 rounded-lg">
                <p className="mb-2"><strong>Jo Allround Service</strong></p>
                <p className="mb-2">Inhaberin: Nancy Born</p>
                <p className="mb-2">Kiefernweg 1</p>
                <p className="mb-2">16831 Rheinsberg</p>
                <p className="mb-2">Deutschland</p>
              </div>
            </section>

            {/* Kontaktdaten */}
            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Kontakt</h2>
              <div className="bg-gray-50 p-6 rounded-lg">
                <div className="grid md:grid-cols-2 gap-6">
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-2">Inhaberin</h3>
                    <p className="text-gray-700">Nancy Born</p>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-2">Telefon</h3>
                    <p className="text-gray-700">Büro: 0175 / 7 44 30 33</p>
                    <p className="text-gray-700">Außendienst: 0160 / 117 29 60</p>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-2">E-Mail</h3>
                    <p className="text-gray-700">info.joallround@gmail.com</p>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-2">Website</h3>
                    <p className="text-gray-700">jo-allround.de</p>
                  </div>
                </div>
              </div>
            </section>

            {/* Verantwortlich für den Inhalt */}
            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
              <div className="bg-gray-50 p-6 rounded-lg">
                <p><strong>Nancy Born</strong></p>
                <p>Kiefernweg 1</p>
                <p>16831 Rheinsberg</p>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Standorte</h2>
              <div className="bg-gray-50 p-6 rounded-lg space-y-4">
                <div>
                  <p className="font-semibold mb-2">Außendienstsitz:</p>
                  <p>Kiefernweg 1</p>
                  <p>16831 Rheinsberg</p>
                </div>
                <div>
                  <p className="font-semibold mb-2">Bürostandort:</p>
                  <p>Heinrich-Heine-Str. 120</p>
                  <p>38855 Wernigerode</p>
                </div>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Redaktionell verantwortlich</h2>
              <div className="bg-gray-50 p-6 rounded-lg">
                <p>Nancy Born</p>
                <p>Kiefernweg 1</p>
                <p>16831 Rheinsberg</p>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">EU-Streitschlichtung</h2>
              <div className="bg-gray-50 p-6 rounded-lg">
                <p className="mb-4">
                  Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: 
                  <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-green-600 hover:text-green-700 ml-1">
                    https://ec.europa.eu/consumers/odr/
                  </a>
                </p>
                <p>Unsere E-Mail-Adresse finden Sie oben im Impressum.</p>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Verbraucherstreitbeilegung/Universalschlichtungsstelle</h2>
              <div className="bg-gray-50 p-6 rounded-lg">
                <p>
                  Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer 
                  Verbraucherschlichtungsstelle teilzunehmen.
                </p>
              </div>
            </section>

            {/* Haftungsausschluss */}
            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Haftungsausschluss</h2>
              <div className="bg-gray-50 p-6 rounded-lg space-y-4">
                <div>
                  <h3 className="font-semibold text-gray-900 mb-2">Haftung für Inhalte</h3>
                  <p className="text-gray-700">
                    Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den 
                    allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht 
                    unter der Verpflichtung, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach 
                    Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
                  </p>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900 mb-2">Haftung für Links</h3>
                  <p className="text-gray-700">
                    Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. 
                    Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der 
                    verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
                  </p>
                </div>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Urheberrecht</h2>
              <div className="bg-gray-50 p-6 rounded-lg">
                <p className="mb-4">
                  Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem 
                  deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung 
                  außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors 
                  bzw. Erstellers.
                </p>
                <p>
                  Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet. 
                  Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte 
                  Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem 
                  auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. 
                  Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
                </p>
              </div>
            </section>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default ImpressumPage;
